<div *ngIf="showMessage" class="error">
    {{ message }}
</div>
<div *ngIf="!showMessage">&nbsp;</div>
